import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { infDb } from "../firebase-inf";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

const Influencer = () => {
  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const influencersPerPage = 9; // ✅ Show 9 per page (3x3 layout)

  const navigate = useNavigate();

 useEffect(() => {
  const fetchInfluencers = async () => {
    try {
      const snapshot = await getDocs(collection(infDb, "influencers"));
      let list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      // ✅ Move pinned influencers to the top
      list.sort((a, b) => (b.pinned === true) - (a.pinned === true));

      setInfluencers(list);
    } catch (err) {
      console.error("Failed to fetch influencers:", err);
      setError("Failed to load influencers.");
    } finally {
      setLoading(false);
    }
  };

  fetchInfluencers();
}, []);


  // Pagination logic
  const indexOfLast = currentPage * influencersPerPage;
  const indexOfFirst = indexOfLast - influencersPerPage;
  const currentInfluencers = influencers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(influencers.length / influencersPerPage);

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
      {/* Sidebar for desktop */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      <div className="flex-1 flex flex-col">
        <Header />

        {/* Sidebar for mobile */}
        <div className="block md:hidden">
          <Sidebar />
        </div>

        <main className="p-6 pricing-main">
          <div className="mb-8">
            <h2 className="text-xl md:text-3xl font-bold bg-gradient-to-r from-[#3913C5] to-[#FF5F00] bg-clip-text text-transparent animate-slide-left">
              Meet the Models of Tomorrow
            </h2>
            <p className="mt-2 text-gray-700 text-base md:text-lg max-w-2xl animate-fade-in">
              Explore a curated lineup of virtual try-on influencers tailored to elevate your brand experience. 
              Select a profile to preview models and start collaborating.
            </p>
          </div>

          {loading ? (
            <div className="text-center mt-10 text-lg">Loading influencers...</div>
          ) : error ? (
            <div className="text-center mt-10 text-red-500">{error}</div>
          ) : influencers.length === 0 ? (
            <div className="text-center text-gray-500">No influencers found.</div>
          ) : (
            <>
              {/* ✅ Grid layout: 3 columns per row */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
                {currentInfluencers.map((influencer) => (
                  <div
                    key={influencer.id}
                    onClick={() => navigate(`/influencer/${influencer.id}`)}
                    className="cursor-pointer bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-lg transition duration-300 hover:scale-105 overflow-hidden"
                  >
                    <div className="relative w-full h-[400px] bg-gray-50">
                      <img
                        src={influencer.images?.[0]}
                        alt={influencer.name}
                        className="w-full h-full object-contain p-4"
                      />
                    </div>
                    <div className="p-4 text-center">
                      <h3 className="text-lg font-semibold text-gray-800 mb-1">
                        <a
                          href={`https://instagram.com/${influencer.instagram}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline"
                          onClick={(e) => e.stopPropagation()}
                        >
                          @{influencer.instagram}
                        </a>
                      </h3>
                    </div>
                  </div>
                ))}
              </div>

              {/* ✅ Pagination Controls */}
              <div className="flex justify-center items-center mt-10 gap-6">
                <button
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="px-5 py-2 text-sm rounded-lg bg-gray-100 hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  Previous
                </button>

                <span className="text-sm font-medium text-gray-700">
                  Page <span className="text-blue-600 font-semibold">{currentPage}</span> of{" "}
                  <span className="text-blue-600 font-semibold">{totalPages}</span>
                </span>

                <button
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="px-5 py-2 text-sm rounded-lg bg-gray-100 hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>

              <div>
                <h2 className="text-right mt-2 text-sm font-semibold">
                  For more details - contact us at: +91 9560093139
                </h2>
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default Influencer;
